import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getAnalyticsOverview, AnalyticsOverview } from '../services/adminApi';

const AnalyticsPage = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState<AnalyticsOverview | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAnalyticsOverview()
      .then(setStats)
      .catch((err) => setError(err.message));
  }, []);

  return (
    <div style={{ display: 'grid', gap: '1.5rem' }}>
      <div>
        <h3>{t('pages.analyticsTitle')}</h3>
        <p>{t('pages.analyticsDescription')}</p>
      </div>
      {error && <div style={{ color: '#b91c1c' }}>{error}</div>}
      {stats ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: '1rem' }}>
          <article style={{ padding: '1rem', borderRadius: 16, border: '1px solid #cbd5e1', background: '#fff' }}>
            <p>{t('pages.analyticsTotalProjects')}</p>
            <p style={{ fontSize: '1.5rem', fontWeight: 700 }}>{stats.totalProjects}</p>
          </article>
          <article style={{ padding: '1rem', borderRadius: 16, border: '1px solid #cbd5e1', background: '#fff' }}>
            <p>{t('pages.analyticsOpenJobs')}</p>
            <p style={{ fontSize: '1.5rem', fontWeight: 700 }}>{stats.openJobs}</p>
          </article>
          <article style={{ padding: '1rem', borderRadius: 16, border: '1px solid #cbd5e1', background: '#fff' }}>
            <p>{t('pages.analyticsContactInquiries')}</p>
            <p style={{ fontSize: '1.5rem', fontWeight: 700 }}>{stats.contactMessages}</p>
          </article>
          <article style={{ padding: '1rem', borderRadius: 16, border: '1px solid #cbd5e1', background: '#fff' }}>
            <p>{t('pages.analyticsApplications')}</p>
            <p style={{ fontSize: '1.5rem', fontWeight: 700 }}>{stats.jobApplications}</p>
          </article>
        </div>
      ) : (
        <div>{t('pages.analyticsLoading')}</div>
      )}
    </div>
  );
};

export default AnalyticsPage;
